var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1595_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.999 14.2216C24.999 13.4017 24.931 12.8034 24.7836 12.183H15.2031V15.8834H20.8267C20.7133 16.8031 20.1011 18.188 18.7405 19.1186L18.7214 19.2425L21.7506 21.5357L21.9605 21.5561C23.8879 19.8166 24.999 17.2573 24.999 14.2216Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2055 23.9715C17.9606 23.9715 20.2735 23.0851 21.9629 21.5562L18.7429 19.1186C17.8812 19.7059 16.7248 20.1158 15.2055 20.1158C12.5071 20.1158 10.2169 18.3764 9.40048 15.9722L9.28082 15.9821L6.13104 18.3642L6.08984 18.4761C7.76783 21.7334 11.2146 23.9715 15.2055 23.9715Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39905 15.9721C9.18363 15.3516 9.05897 14.6868 9.05897 13.9999C9.05897 13.313 9.18363 12.6483 9.38772 12.0278L9.38201 11.8957L6.19276 9.47534L6.08841 9.52384C5.39683 10.8755 5 12.3934 5 13.9999C5 15.6065 5.39683 17.1243 6.08841 18.476L9.39905 15.9721Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2055 7.88416C17.1216 7.88416 18.4141 8.69295 19.1511 9.36884L22.0309 6.62114C20.2622 5.01463 17.9606 4.02856 15.2055 4.02856C11.2146 4.02856 7.76783 6.26658 6.08984 9.52389L9.38915 12.0279C10.2169 9.62364 12.5071 7.88416 15.2055 7.88416Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1595_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4e7aca71f0377de3315994d20dbb354b.svg";
export { ForwardRef as ReactComponent };